import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/NewsDetails",
        name: "NewsDetails",
        component: () => import("@/components/customer/news/news-details.vue"),
      },
      // {
      //   path: "/dashboard-e-learning",
      //   name: "e-learning",
      //   component: () =>
      //     import("@/views/customer/training/dashboard-e-learning.vue"),
      // },
      {
        path: "/e-learning-lession",
        name: "e-learning-lession",
        component: () =>
          import("@/views/customer/training/e-learning-lession.vue"),
      },
      {
        path: "/e-learning-course-details",
        name: "e-learning-course-details",
        component: () =>
          import("@/views/customer/training/e-learning-course-details.vue"),
      },
      {
        path: "/my-lession-details",
        name: "my-lession-details",
        component: () =>
          import("@/views/customer/training/my-lession-details.vue"),
      },
      {
        path: "/quiz",
        name: "quiz",
        component: () => import("@/views/customer/training/quiz.vue"),
      },
      // {
      //   path: "/elearning-lession-history",
      //   name: "elearning-lession-history",
      //   component: () =>
      //     import("@/views/customer/training/elearning-lession-history.vue"),
      // },
      // {
      //   path: "/dashboard-online-training",
      //   name: "dashboard-online-training",
      //   component: () =>
      //     import("@/views/customer/training/dashboard-online-training.vue"),
      // },
      {
        path: "/online-lession",
        name: "online-lession",
        component: () => import("@/views/customer/training/online-lession.vue"),
      },
      {
        path: "/course-details",
        name: "course-details",
        component: () => import("@/views/customer/training/course-details.vue"),
      },
      {
        path: "/online-my-lession-details",
        name: "online-my-lession-details",
        component: () =>
          import("@/views/customer/training/online-my-lession-details.vue"),
      },
      // {
      //   path: "/online-lession-history",
      //   name: "online-lession-history",
      //   component: () =>
      //     import("@/views/customer/training/online-lession-history.vue"),
      // },
      {
        path: "/dashboard-onsite-training",
        name: "dashboard-onsite-training",
        component: () =>
          import("@/views/customer/training/dashboard-onsite-training.vue"),
      },
      // {
      //   path: "elearning/questionnaire-history",
      //   name: "elearning-questionnaire-history",
      //   component: () =>
      //     import(
      //       "@/views/customer/training/elearning-questionnaire-history.vue"
      //     ),
      // },
      // {
      //   path: "online/questionnaire-history",
      //   name: "online-questionnaire-history",
      //   component: () =>
      //     import("@/views/customer/training/online-questionnaire-history.vue"),
      // },

      // {
      //   // ไม่ใช้แล้ว
      //   path: "/FormDiProm",
      //   name: "FormDiProm",
      //   component: () => import("@/views/FormDiProm.vue"),
      // },
      // {
      //   path: "/FormA",
      //   name: "FormA",
      //   component: () => import("@/views/customer/form-diprom/FormA.vue"),
      // },
      {
        path: "/FormB",
        name: "FormB",
        component: () => import("@/views/customer/form-diprom/FormB/FormB.vue"),
        children: [
          {
            path: "FormB01",
            name: "FormB-FormB01",
            component: () =>
              import("@/views/customer/form-diprom/FormB/FormB01.vue"),
          },
          {
            path: "FormB02",
            name: "FormB-FormB02",
            component: () =>
              import("@/views/customer/form-diprom/FormB/FormB02.vue"),
          },
        ],
      },
      {
        path: "/FormB03",
        name: "FormB03",
        component: () =>
          import("@/views/customer/form-diprom/FormB/FormB03/FormB03M.vue"),
      },
      {
        path: "/FormB03-1/:id",
        name: "FormB03-1",
        component: () =>
          import("@/views/customer/form-diprom/FormB/FormB03/FormB03-1.vue"),

        children: [
          {
            path: "/FormB03-1/Data/:id/:ecoLoanRequestId",
            name: "FormB03-1-Data",
            component: () =>
              import(
                "@/views/customer/form-diprom/FormB/FormB03/FormB03-1-Data.vue"
              ),
          },
          // {
          //   path: "/FormB03-1/Company/:id/:ecoLoanRequestId",
          //   name: "FormB03-1-Company",
          //   component: () =>
          //     import(
          //       "@/views/customer/form-diprom/FormB/FormB03/FormB03-1-Data-Company.vue"
          //     ),
          // },
          {
            path: "/FormB03-1/CoBorrow/:id/:ecoLoanRequestId",
            name: "FormB03-1-CoBorrow",
            component: () =>
              import(
                "@/views/customer/form-diprom/FormB/FormB03/FormB03-1-Data-CoBorrow.vue"
              ),
          },
          {
            path: "/FormB03-1/Warrantee/:id/:ecoLoanRequestId",
            name: "FormB03-1-Warrantee",
            component: () =>
              import(
                "@/views/customer/form-diprom/FormB/FormB03/FormB03-1-Data-Warrantee.vue"
              ),
          },
          {
            path: "/FormB03-1/References/:id/:ecoLoanRequestId",
            name: "FormB03-1-References",
            component: () =>
              import(
                "@/views/customer/form-diprom/FormB/FormB03/FormB03-1-Data-References.vue"
              ),
          },
          {
            path: "/FormB03-1/Document/:id/:ecoLoanRequestId",
            name: "FormB03-1-Document",
            component: () =>
              import(
                "@/views/customer/form-diprom/FormB/FormB03/FormB03-1-Document.vue"
              ),
          },
        ],
      },
      {
        path: "/FormC01",
        name: "FormC01",
        component: () =>
          import("@/views/customer/form-diprom/FormC/FormC01/FormCMain.vue"),
      },
      {
        path: "/FormC02",
        name: "FormC02",
        component: () =>
          import("@/views/customer/form-diprom/FormC/FormC02/FormC02Main.vue"),
      },
      {
        path: "/FormC03",
        name: "FormC03",
        component: () =>
          import("@/views/customer/form-diprom/FormC/FormC03/FormC03Main.vue"),
      },
      {
        path: "/FormC04",
        name: "FormC04",
        component: () =>
          import("@/views/customer/form-diprom/FormC/FormC04/FormC04Main.vue"),
      },
      {
        path: "/FormD",
        name: "FormD",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormDMain.vue"),
      },
      {
        path: "/FormD01/Add",
        name: "FormD01Add",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormD01Add.vue"),
      },
      {
        path: "/FormD01/Edit/:memberBusinessId",
        name: "FormD01Edit",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormD01Edit.vue"),
      },
      {
        path: "/FormD01Sub1/Add",
        name: "FormD01Sub1Add",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormD01-1Add.vue"),
      },
      {
        path: "/FormD01Sub1/Edit/:businessFocusId",
        name: "FormD01Sub1Edit",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormD01-1Edit.vue"),
      },
      {
        path: "/FormD01Sub2/Add",
        name: "FormD01Sub2Add",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormD01-2Add.vue"),
      },
      {
        path: "/FormD01Sub2/Edit/:businessProductId",
        name: "FormD01Sub2Edit",
        component: () =>
          import("@/views/customer/form-diprom/FormD/FormD01-2Edit.vue"),
      },
      {
        path: "/FormE01/Main",
        name: "FormE01Main",
        component: () =>
          import("@/views/customer/form-diprom/FormE/E01/FormE01Main.vue"),
      },
      {
        path: "/FormE01/Add",
        name: "FormE01Add",
        component: () =>
          import("@/views/customer/form-diprom/FormE/E01/FormE01Add.vue"),
      },
      {
        path: "/FormE01/Edit/:businessId",
        name: "FormE01Edit",
        component: () =>
          import("@/views/customer/form-diprom/FormE/E01/FormE01Edit.vue"),
      },
      {
        path: "/FormE01Sub1/Add",
        name: "FormE01Sub1Add",
        component: () =>
          import("@/views/customer/form-diprom/FormE/E01/FormE01_1Add.vue"),
      },
      {
        path: "/FormE01Sub1/Edit/:businessFactoryId",
        name: "FormE01Sub1Edit",
        component: () =>
          import("@/views/customer/form-diprom/FormE/E01/FormE01_1Edit.vue"),
      },
      {
        path: "/FormE02",
        name: "FormE02",
        component: () =>
          import("@/views/customer/form-diprom/FormE/E02/FormE02Main.vue"),
      },
      // {
      //   //ปิดก่อนเพราะไม่ได้ใช้
      //   path: "/FormE02Sub1/Add",
      //   name: "FormE02Sub1Add",
      //   component: () =>
      //     import("@/views/customer/form-diprom/FormE/E02/FormE02-1Add.vue"),
      // },
      // {
      //   //ปิดก่อนเพราะไม่ได้ใช้
      //   path: "/FormE02Sub1/Edit/:businessDataId",
      //   name: "FormE02Sub1Edit",
      //   component: () =>
      //     import("@/views/customer/form-diprom/FormE/E02/FormE02-1Edit.vue"),
      // },
      // {
      //   //ปิดไปเลย เพราะไปแสดงที่หน้า E02 แล้ว
      //   path: "/FormE02/QuesionnaireISingleFormLite",
      //   name: "FormE02QuesionnaireISingleFormLite",
      //   component: () =>
      //     import(
      //       "@/views/customer/form-diprom/FormE/E02/FormE02-ISingleFormLite-Questionnaire.vue"
      //     ),
      // },
      {
        path: "/FormF",
        name: "FormF",
        component: () =>
          import("@/views/customer/form-diprom/FormF/FormF01-1.vue"),
      },
      {
        path: "/FormF/List",
        name: "FormFList",
        component: () =>
          import("@/views/customer/form-diprom/FormF/FormF01-1-List.vue"),
      },
      {
        path: "/FormG",
        name: "FormG",
        component: () =>
          import("@/views/customer/form-diprom/FormG/FormGMain.vue"),
      },
      {
        path: "/FormG01",
        name: "FormG01",
        component: () =>
          import("@/views/customer/form-diprom/FormG/FormG01.vue"),
      },
      {
        path: "/FormG01-1",
        name: "FormG01-1",
        component: () =>
          import("@/views/customer/form-diprom/FormG/FormG01-1.vue"),
      },
      {
        path: "/FormH",
        name: "FormH",
        component: () =>
          import("@/views/customer/form-diprom/FormH/FormHMain.vue"),
      },
      {
        path: "/FormH01",
        name: "FormH01",
        component: () =>
          import("@/views/customer/form-diprom/FormH/FormH01.vue"),
      },
      {
        path: "/FormH01-1",
        name: "FormH01-1",
        component: () =>
          import("@/views/customer/form-diprom/FormH/FormH01-1.vue"),
      },
      {
        path: "/MainFunding",
        name: "MainFunding",
        component: () => import("@/views/customer/funding/MainFunding.vue"),
      },
      {
        path: "/TrackMyStatus",
        name: "TrackMyStatus",
        component: () => import("@/views/customer/funding/track-my-status.vue"),
      },
      {
        path: "/BusinessCheckupQuestionnaire",
        name: "BusinessCheckupQuestionnaire",
        component: () =>
          import(
            "@/views/customer/business_checkup/BusinessCheckupQuestionnaire.vue"
          ),
      },
      {
        path: "/BusinessCheckupQuestionnaireAndQuestion/:id",
        name: "BusinessCheckupQuestionnaireAndQuestion",
        component: () =>
          import(
            "@/views/customer/business_checkup/BusinessCheckupQuestionnaireAndQuestion.vue"
          ),
      },
      {
        path: "/BusinessCheckupQuestionnaireAnswerHistory",
        name: "BusinessCheckupQuestionnaireAnswerHistory",
        component: () =>
          import(
            "@/views/customer/business_checkup/BusinessCheckupQuestionnaireAnswerHistory.vue"
          ),
      },
      {
        path: "/BusinessCheckupQuestionnaireSummaryReport/:id",
        name: "BusinessCheckupQuestionnaireSummaryReport",
        component: () =>
          import(
            "@/views/customer/business_checkup/BusinessCheckupQuestionnaireSummaryReport.vue"
          ),
      },
      {
        path: "/ViewShareQuestionnaire",
        name: "ViewShareQuestionnaire",
        component: () =>
          import(
            "@/views/customer/ShareQuestionnaire/ViewShareQuestionnaire.vue"
          ),
      },
      {
        path: "/ViewShareQuestionnaireAndQuestion/:id",
        name: "ViewShareQuestionnaireAndQuestion",
        component: () =>
          import(
            "@/views/customer/ShareQuestionnaire/ViewShareQuestionnaireAndQuestion.vue"
          ),
      },
      {
        path: "/ViewShareQuestionnaireAnswerHistory",
        name: "ViewShareQuestionnaireAnswerHistory",
        component: () =>
          import(
            "@/views/customer/ShareQuestionnaire/ViewShareQuestionnaireAnswerHistory.vue"
          ),
      },
      // {
      //   // TODO: ปิดก่อนไม่ได้ใช้, ข่าวสาร ประชาสัมพันธ์ โครงการ ของ สัญญาจ้าง แบบเป็นรายการ
      //   path: "/ContractorworkNews",
      //   name: "ContractorworkNews",
      //   component: () =>
      //     import("@/views/customer/Contractorwork/ContractorworkNews.vue"),
      // },
      // {
      //   // TODO: ปิดก่อนไม่ได้ใช้, ข่าวสาร ประชาสัมพันธ์ โครงการ ของ สัญญาจ้าง แบบรายละเอียด
      //   path: "/ContractorworkNewsDetail/:projectCourseId",
      //   name: "ContractorworkNewsDetail",
      //   component: () =>
      //     import(
      //       "@/views/customer/Contractorwork/ContractorworkNewsDetail.vue"
      //     ),
      // },
      {
        path: "/ContractorworkMyProject",
        name: "ContractorworkMyProject",
        component: () =>
          import("@/views/customer/Contractorwork/ContractorworkMyProject.vue"),
      },
      {
        path: "/ContractorworkMyProjectHistory",
        name: "ContractorworkMyProjectHistory",
        component: () =>
          import(
            "@/views/customer/Contractorwork/ContractorworkMyProjectHistory.vue"
          ),
      },
      {
        path: "/ContractorworkMyProjectQuestionnaire",
        name: "ContractorworkMyProjectQuestionnaire",
        component: () =>
          import(
            "@/views/customer/Contractorwork/ContractorworkMyProjectQuestionnaire.vue"
          ),
      },
      {
        path: "/ContractorworkMyProjectDetail/:projectCourseId/projectId/:projectId",
        name: "ContractorworkMyProjectDetail",
        component: () =>
          import(
            "@/views/customer/Contractorwork/ContractorworkMyProjectDetail.vue"
          ),
      },
      // {
      //   // TODO: ปิดก่อนไม่ได้ใช้, รายงานผลการให้คำปรึกษาแนะนำรายกิจการ
      //   path: "/ContractorworkSummaryReportMyProject",
      //   name: "ContractorworkSummaryReportMyProject",
      //   component: () =>
      //     import(
      //       "@/views/customer/Contractorwork/ContractorworkSummaryReportMyProject.vue"
      //     ),
      // },
      // {
      //   //TODO: ปิดก่อนไม่ได้ใช้
      //   path: "/BusinessInformation/Tool",
      //   name: "BusinessInformationTool",
      //   component: () =>
      //     import(
      //       "@/views/customer/business-information-tool/business-tool.vue"
      //     ),
      // },
      // {
      //   //TODO: ปิดก่อนไม่ได้ใช้
      //   path: "/BusinessInformation/ToolDetails",
      //   name: "BusinessInformationToolDetails",
      //   component: () =>
      //     import(
      //       "@/views/customer/business-information-tool/business-tool-details.vue"
      //     ),
      // },
      {
        path: "/Seller/Store",
        name: "SellerStore",
        component: () =>
          import("@/views/customer/marketplace/seller/store.vue"),
      },
      {
        path: "/Seller/StoreList",
        name: "SellerStoreList",
        component: () =>
          import("@/views/customer/marketplace/seller/store-list.vue"),
      },
      {
        path: "/Seller/OrderList",
        name: "SellerOrderList",
        component: () =>
          import("@/views/customer/marketplace/seller/order-list.vue"),
      },
      {
        path: "/Seller/OrderDetails",
        name: "SellerOrderDetails",
        component: () =>
          import("@/views/customer/marketplace/seller/order-details.vue"),
      },
      {
        path: "/Seller/ProductList",
        name: "SellerProductList",
        component: () =>
          import("@/views/customer/marketplace/seller/product-list.vue"),
      },
      {
        path: "/Seller/Product",
        name: "SellerProduct",
        component: () =>
          import("@/views/customer/marketplace/seller/product.vue"),
      },
      {
        path: "/Buyer/ProductCatalog",
        name: "BuyerProductCatalog",
        component: () =>
          import("@/views/customer/marketplace/buyer/product-catalog.vue"),
      },
      {
        path: "/Buyer/OrderList",
        name: "BuyerOrderList",
        component: () =>
          import("@/views/customer/marketplace/buyer/order-list.vue"),
      },
      {
        path: "/Buyer/OrderDetails",
        name: "BuyerOrderDetails",
        component: () =>
          import("@/views/customer/marketplace/buyer/order-details.vue"),
      },
      {
        path: "/Buyer/CheckoutPayment",
        name: "BuyerCheckoutPayment",
        component: () =>
          import("@/views/customer/marketplace/buyer/checkout-payment.vue"),
      },
      {
        path: "/Buyer/ProductDetails",
        name: "BuyerProductDetails",
        component: () =>
          import("@/views/customer/marketplace/buyer/product-details.vue"),
      },
      {
        // ผู้เชียวชาญดีพร้อม
        path: "/ConsultingSearch",
        name: "ConsultingSearch",
        component: () =>
          import("@/views/customer/Consult/ConsultingSearch.vue"),
      },
      {
        // ค้นหาผู้เชี่ยวชาญดีพร้อม
        path: "/ConsultantDirectorySearch",
        name: "ConsultantDirectorySearch",
        component: () =>
          import("@/views/customer/Consult/ConsultantDirectorySearch.vue"),
      },
      {
        // รายละเอียดนัดหมาย กดจากตอนจองนัดหมาย (ผู้เชียวชาญดีพร้อม)
        path: "/ConsultingDetail/:consutltCourseId",
        name: "ConsultingDetail",
        component: () =>
          import("@/views/customer/Consult/ConsultingDetail.vue"),
      },
      {
        // รายละเอียดที่ปรึกษา เหมือนหน้านัดหมาย แต่ เอานัดหมายออก (ผู้เชียวชาญดีพร้อม)
        path: "/ConsultingDetailProfile/:consultantId",
        name: "ConsultingDetailProfile",
        component: () =>
          import("@/views/customer/Consult/ConsultingDetailProfile.vue"),
      },
      {
        // นัดหมายที่ปรึกษา
        path: "/ConsultingMyAppointment",
        name: "ConsultingMyAppointment",
        component: () =>
          import("@/views/customer/Consult/ConsultingMyAppointment.vue"),
      },
      {
        // นัดหมายที่ปรึกษา แบบประเมิน
        path: "/ConsultingMyAppointmentQuestionnaire",
        name: "ConsultingMyAppointmentQuestionnaire",
        component: () =>
          import(
            "@/views/customer/Consult/ConsultingMyAppointmentQuestionnaire.vue"
          ),
      },
      {
        // หน้าแสดงข้อมูลให้คำปรึกษา ของผู้เชี่ยวชาญ
        path: "/ViewConsultantMyAppointment",
        name: "ViewConsultantMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Consult/Consultant/ViewConsultantMyAppointment.vue"
          ),
      },
      {
        // หน้าสร้างให้คำปรึกษา ของผู้เชี่ยวชาญ
        path: "/ConsultantAddMyAppointment",
        name: "ConsultantAddMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Consult/Consultant/ConsultantAddMyAppointment.vue"
          ),
      },
      {
        // หน้าจัดการให้คำปรึกษา ของผู้เชี่ยวชาญ (แสดงผล + แก้ไข)
        path: "/ConsultantManageMyAppointment/:serviceConsultantId",
        name: "ConsultantManageMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Consult/Consultant/ConsultantManageMyAppointment.vue"
          ),
      },
      {
        // หน้าสรุปการนัดหมาย ตาม id ที่ปรึกษาใช้
        path: "/ConsultantSummaryMyAppointment/:serviceConsultantId",
        name: "ConsultantSummaryMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Consult/Consultant/ConsultantSummaryMyAppointment.vue"
          ),
      },
      {
        // TODO: เช็คอีกที
        //TODO: production ปิด
        path: "/MatchingSearch",
        name: "MatchingSearch",
        component: () => import("@/views/customer/Matching/MatchingSearch.vue"),
      },
      {
        // ค้นหา จับคู่ธุรกิจ
        //TODO: production ปิด
        path: "/MatchingDirectorySearch",
        name: "MatchingDirectorySearch",
        component: () =>
          import("@/views/customer/Matching/MatchingDirectorySearch.vue"),
      },
      {
        // TODO: เช็คอีกที
        //TODO: production ปิด
        path: "/MatchingDetail/:matchingCourseId",
        name: "MatchingDetail",
        component: () => import("@/views/customer/Matching/MatchingDetail.vue"),
      },
      {
        // รายละเอียด จับคู่ธุรกิจ เหมือนหน้านัดหมาย แต่ เอานัดหมายออก
        //TODO: production ปิด
        path: "/MatchingDetailProfile/:businessMatchingId",
        name: "MatchingDetailProfile",
        component: () =>
          import("@/views/customer/Matching/MatchingDetailProfile.vue"),
      },
      {
        // TODO: เช็คอีกที
        //TODO: production ปิด
        path: "/MatchingMyAppointment",
        name: "MatchingMyAppointment",
        component: () =>
          import("@/views/customer/Matching/MatchingMyAppointment.vue"),
      },
      {
        // TODO: เช็คอีกที
        //TODO: production ปิด
        // นัดหมายจับคู่ธุรกิจ แบบประเมิน
        path: "/MatchingMyAppointmentQuestionnaire",
        name: "MatchingMyAppointmentQuestionnaire",
        component: () =>
          import(
            "@/views/customer/Matching/MatchingMyAppointmentQuestionnaire.vue"
          ),
      },
      {
        // หน้าแสดงข้อมูลจับคู่ธุรกิจ ของผู้ให้บริการ
        //TODO: production ปิด
        path: "/ViewMatchingMyAppointment",
        name: "ViewMatchingMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Matching/ViewMatchingMyAppointment.vue"
          ),
      },
      {
        // หน้าจัดการนัดหมาย/สร้างห้องนัดหมาย
        //TODO: production ปิด
        path: "/MatchingAddMyAppointment",
        name: "MatchingAddMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Matching/MatchingAddMyAppointment.vue"
          ),
      },
      {
        // หน้าจัดการ จับคู่ธุรกิจ ของผู้ใช้บริการ (แสดงผล + แก้ไข)
        //TODO: production ปิด
        path: "/MatchingManageMyAppointment/:serviceMatchingId",
        name: "MatchingManageMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Matching/MatchingManageMyAppointment.vue"
          ),
      },
      {
        // หน้าสรุปการนัดหมาย ตาม id ผู้ให้บริการใช้
        //TODO: production ปิด
        path: "/MatchingSummaryMyAppointment/:serviceMatchingId",
        name: "MatchingSummaryMyAppointment",
        component: () =>
          import(
            "@/views/customer/PartOfUs/Matching/MatchingSummaryMyAppointment.vue"
          ),
      },
      {
        path: "/ComeBePartOfUs",
        name: "ComeBePartOfUs",
        component: () =>
          import("@/views/customer/PartOfUs/come-be-part-of-us.vue"),
      },
      {
        path: "/ComeBePartOfUsConsultant",
        name: "ComeBePartOfUsConsultant",
        component: () =>
          import("@/views/customer/PartOfUs/ComeBePartOfUsConsultant.vue"),
      },
      {
        // หน้าร่วมเป็นส่วนหนึ่งกับเราของ business matching
        //TODO: production ปิด
        path: "/ComeBePartOfUsMatching",
        name: "ComeBePartOfUsMatching",
        component: () =>
          import("@/views/customer/PartOfUs/ComeBePartOfUsMatching.vue"),
      },
      {
        path: "/ComeBePartOfUsMarketplace",
        name: "ComeBePartOfUsMarketplace",
        component: () =>
          import("@/views/customer/PartOfUs/ComeBePartOfUsMarketplace.vue"),
      },
      {
        path: "/JoinEvent/Dashboard",
        name: "JoinEventDashboard",
        component: () => import("@/views/customer/JoinEvent/dashboard.vue"),
      },
      {
        path: "/JoinEvent/OnlineDashboard",
        name: "JoinEventOnlineDashboard",
        component: () => import("@/views/customer/JoinEvent/dashboard2.vue"),
      },
      {
        path: "/JoinEvent/OnlineCourseDashboard",
        name: "JoinEventOnlineCourseDashboard",
        component: () =>
          import("@/views/customer/JoinEvent/dashboard-online-course.vue"),
      },
      {
        path: "/JoinEvent/Details",
        name: "JoinEventDetails",
        component: () => import("@/views/customer/JoinEvent/details.vue"),
      },
      // {
      //   path: "/JoinEvent/History",
      //   name: "JoinEventHistory",
      //   component: () => import("@/views/customer/JoinEvent/history.vue"),
      // },
      {
        path: "/Knowledge",
        name: "Knowledge",
        component: () => import("@/views/customer/knowledge/knowledge.vue"),
      },
      {
        path: "/KnowledgeSubCategory",
        name: "KnowledgeSubCategory",
        component: () =>
          import("@/views/customer/knowledge/knowledge-sub-category.vue"),
      },
      {
        path: "/ServiceHistory",
        name: "ServiceHistory",
        component: () =>
          import("@/views/customer/service-history/service-history.vue"),
        children: [
          {
            path: "/ServiceHistory/JoinEvent/History",
            name: "JoinEventHistory1",
            component: () => import("@/views/customer/JoinEvent/history.vue"),
          },
          {
            path: "/ServiceHistory/elearning-lession-history",
            name: "elearning-lession-history",
            component: () =>
              import("@/views/customer/training/elearning-lession-history.vue"),
          },
          {
            path: "/ServiceHistory/online-lession-history",
            name: "online-lession-history",
            component: () =>
              import("@/views/customer/training/online-lession-history.vue"),
          },
        ],
      },
      {
        path: "/AssessmentHistory",
        name: "AssessmentHistory",
        component: () =>
          import("@/views/customer/service-history/assessment-history.vue"),
        children: [
          {
            path: "/AssessmentHistory/JoinEvent/History",
            name: "AssessmentHistory-JoinEventHistory",
            component: () =>
              import("@/views/customer/JoinEvent/history-assessment.vue"),
          },
          {
            path: "/AssessmentHistory/elearning/questionnaire-history",
            name: "AssessmentHistory-elearning-questionnaire-history",
            component: () =>
              import(
                "@/views/customer/training/elearning-questionnaire-history.vue"
              ),
          },
          {
            path: "/AssessmentHistory/online/questionnaire-history",
            name: "AssessmentHistory-online-questionnaire-history",
            component: () =>
              import(
                "@/views/customer/training/online-questionnaire-history.vue"
              ),
          },
        ],
      },
      {
        path: "/AbountUs",
        name: "AbountUs",
        component: () => import("@/views/AboutUs.vue"),
      },
      {
        path: "/ContactUsList",
        name: "ContactUsList",
        component: () =>
          import("@/views/customer/contact-us/ContactUsList.vue"),
      },
      {
        path: "/ContactUs",
        name: "ContactUs",
        component: () => import("@/views/customer/contact-us/ContactUs.vue"),
      },
      {
        path: "/DiPromManual",
        name: "DiPromManual",
        component: () =>
          import("@/views/customer/DipromManual/DiPromManual.vue"),
      },
      {
        path: "/DiPromManual/Details",
        name: "DiPromManualDetails",
        component: () => import("@/views/customer/DipromManual/Details.vue"),
      },
      {
        path: "/SmeDBank/RequestLoanHistory",
        name: "SmeDBankRequestLoanHistory",
        component: () =>
          import("@/views/customer/SmeDBank/ViewRequestLoanHistory.vue"),
      },
      {
        //เมนู ปฏิทินโครงการดีพร้อม
        path: "/Project/ProjectCourseCalendar",
        name: "ProjectCourseCalendar",
        component: () =>
          import("@/views/customer/Project/ViewProjectCourseCalendar.vue"),
      },
    ],
  },
  {
    path: "/preview-pdf",
    name: "preview-pdf",
    component: () => import("@/components/customer/training/preview-pdf.vue"),
  },
  // {
  //   path: "/",
  //   component: () => import("@/components/page-layouts/AuthAdside.vue"),
  //   children: [
  //     {
  //       path: "/sign-in",
  //       name: "sign-in",
  //       component: () =>
  //         import("@/views/crafted/authentication/basic-flow/SignInAdside.vue"),
  //     },
  //   ],
  // },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-in-connect",
        name: "sign-in-connect",
        component: () =>
          import(
            "@/views/crafted/authentication/basic-flow/SignInFromIIndustry.vue"
          ),
      },
      // {
      //   path: "/sign-in-diprom",
      //   name: "sign-in-diprom",
      //   component: () => import("@/views/SignInDiProm.vue"),
      // },
      // {
      //   path: "/sign-up",
      //   name: "sign-up",
      //   component: () =>
      //     import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      // },
      // {
      //   path: "/password-reset",
      //   name: "password-reset",
      //   component: () =>
      //     import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      // },
    ],
  },
  // {
  //   path: "/multi-step-sign-up",
  //   name: "multi-step-sign-up",
  //   component: () =>
  //     import("@/views/crafted/authentication/MultiStepSignUp.vue"),
  // },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
